import { render, staticRenderFns } from "./AtomPinIconText.vue?vue&type=template&id=116c2fea&"
import script from "./AtomPinIconText.vue?vue&type=script&lang=js&"
export * from "./AtomPinIconText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports